import { combineReducers } from 'redux';
import menuReducer from './Reducer';
import AuthReducer from './AuthReducer';
import LogoutUser from '../Action/ActionTypes/LogoutTypes';

var appReducer = combineReducers({
  menuReducer,
  AuthReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LogoutUser.LOGOUT_USER_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
